import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import RegulatoryOffering from "@/pages/RegulatoryOffering";

export const Route = createFileRoute("/zh-cn/services/regulatory-affairs/materiovigilance")({
  head: () => buildRouteHead("/zh-cn/services/regulatory-affairs/materiovigilance"),
  component: RegulatoryOffering,
});

